import React from "react";
import { Icon, WrappingIconProps } from "../Icon";

export const GoogleAuthenticatorIcon = (props: WrappingIconProps) => {
  return (
    <Icon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Layer_1"
      x={0}
      y={0}
      viewBox="0 0 2481.9 2481.9"
    >
      <style>
        {
          ".st0{fill:#616161}.st1{fill:#9e9e9e}.st3{fill:#212121;fill-opacity:.1}.st6{fill:#bdbdbd}"
        }
      </style>
      <g transform="translate(-27 -27)">
        <circle cx={1268} cy={1268} r={1241} className="st0" />
        <path
          d="M1268 2057.7c-436.2 0-789.7-353.5-789.7-789.7 0-436.2 353.5-789.7 789.7-789.7 218 0 415.4 88.4 558.4 231.3l319.1-319.1C1920.9 165.9 1610.6 27 1268 27 582.6 27 27 582.6 27 1268s555.6 1241 1241 1241c342.7 0 652.9-138.9 877.6-363.4l-319.1-319.1c-143.1 142.8-340.5 231.2-558.5 231.2z"
          className="st1"
        />
        <path
          d="M2057.7 1268h-394.9c0-218-176.8-394.9-394.9-394.9S873.1 1049.9 873.1 1268c0 106.2 42 202.5 110.3 273.6l-.3.3 488.9 488.9.1.1c337.2-90 585.6-397.4 585.6-762.9z"
          fill="#424242"
        />
        <path
          d="M2508.9 1268h-451.3c0 365.5-248.5 672.9-585.5 762.9l348.5 348.5c408-203.3 688.3-624.6 688.3-1111.4z"
          className="st0"
        />
        <path
          d="M1268 2494.8C585 2494.8 31 1943 27.1 1260.9c0 2.4-.1 4.7-.1 7.1 0 685.4 555.6 1241 1241 1241s1241-555.6 1241-1241c0-2.4-.1-4.7-.1-7.1-3.9 682.1-558 1233.9-1240.9 1233.9z"
          className="st3"
        />
        <path
          d="m1472.2 2030.9 11 11c331.4-93.6 574.5-398.2 574.5-759.8V1268c0 365.5-248.5 672.9-585.5 762.9z"
          fill="var(--theme-neutral-0)"
          fillOpacity="0.05"
        />
        <path
          d="M2283.355 1155.155h-1015.4c-62.3 0-112.8 50.5-112.8 112.8s50.5 112.8 112.8 112.8h1015.3c62.3 0 112.8-50.5 112.8-112.8.1-62.3-50.4-112.8-112.7-112.8z"
          className="st1"
        />
        <path
          d="M2046.9 918.7H1031.5c-62.3 0-112.8 50.5-112.8 112.8s50.5 112.8 112.8 112.8h1015.3c62.3 0 112.8-50.5 112.8-112.8.1-62.3-50.4-112.8-112.7-112.8z"
          opacity="0.5"
          fill="#bdbdbd"
          transform="translate(236.455 236.455)"
        />
        <circle cx={252.6} cy={1268} r={84.6} className="st6" />
        <circle cx={1268} cy={252.6} r={84.6} className="st6" />
        <circle cx={1268} cy={2283.3} r={84.6} className="st6" />
        <circle cx={548.8} cy={550} r={84.6} className="st6" />
        <circle cx={548.8} cy={1987.2} r={84.6} className="st6" />
        <circle cx={1987.2} cy={1987.2} r={84.6} fill="#757575" />
        <path
          d="M1268 1169.3h1015.3c59.9 0 108.9 46.8 112.4 105.8.1-2.4.4-4.7.4-7.1 0-62.3-50.5-112.8-112.8-112.8H1268c-62.3 0-112.8 50.5-112.8 112.8 0 2.4.1 4.7.4 7.1 3.5-59 52.4-105.8 112.4-105.8z"
          fill="var(--theme-neutral-0)"
          fillOpacity="0.2"
        />
        <path
          d="M2395.7 1275c-3.7 58.9-52.6 105.8-112.4 105.8H1268c-59.9 0-108.9-46.8-112.4-105.8-.3 2.4-.4 4.7-.4 7 0 62.3 50.5 112.8 112.8 112.8h1015.3c62.3 0 112.8-50.5 112.8-112.8 0-2.3-.1-4.6-.4-7z"
          fill="#212121"
          fillOpacity="0.2"
        />
        <path
          d="M1268 492.4c218 0 415.4 88.4 558.4 231.3l326-326.2c-2.4-2.4-4.7-4.8-7-7.1l-319 319.1c-143-142.9-340.4-231.3-558.4-231.3-436.2 0-789.7 353.5-789.7 789.7 0 2.4.1 4.7.1 7.1 3.8-432.9 355.8-782.6 789.6-782.6z"
          className="st3"
        />
        <radialGradient
          id="SVGID_1_"
          cx={706.725}
          cy={1774.029}
          r={0.998}
          gradientTransform="matrix(2481.9333 0 0 -2481.9333 -1753654.125 4403410.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            stopColor="var(--theme-neutral-0)"
            stopOpacity=" 0.1"
          />
          <stop offset={1} stopColor="var(--theme-neutral-0)" stopOpacity="0" />
        </radialGradient>
        <circle
          cx={1268}
          cy={1268}
          r={1241}
          style={{
            fill: "url(#SVGID_1_)"
          }}
        />
      </g>
    </Icon>
  );
};
